import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/request-new',
    name: 'RequestNew',
    component: () => import('../views/Request.vue'),
    props: { newRoot: true }
  },
  {
    path: '/request/:id',
    name: 'RequestDetail',
    component: () => import('../views/RequestDetail.vue')
  },
  {
    path: '/request',
    name: 'Request',
    component: () => import('../views/Request.vue'),
    props: { newRoot: false }
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import('../views/Registration.vue'),
  },
  {
    path: '/unregistration',
    name: 'Unregistration',
    component: () => import('../views/Unregistration.vue'),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../views/Account.vue'),
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import('../views/PasswordReset.vue'),
  },
  {
    path: '/new-password',
    name: 'NewPassword',
    component: () => import('../views/NewPassword.vue'),
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
